import { isUUID } from 'external/lodash'
import { clsx } from 'external/clsx'
import { useMemo, Button, FC} from 'external/react'
import Icon from 'external/fortawesome'

import Avatar from 'components/Avatar'

import { notifyWarning } from 'components/Notify'
import { Package, PackageState } from 'types/context/package'
import { ContextState, UpdateFunction } from 'types/context/context'

type SelectStudentProps = {
    className?: string
    packageItem: Package | null
    update?: UpdateFunction<ContextState<PackageState>>
    changed?: () => void
}

const SelectStudent:FC<SelectStudentProps> = props => {

	const {changed, update, packageItem, className = 'card flex-grow-1 mb-3 d-flex flex-column justify-content-center'} = props

    const selectedStudent = packageItem?.student

    const hasStudent = useMemo(() => isUUID(selectedStudent?.id), [selectedStudent])

    function handleSelectStudentClick() {
        const selectStudentModal = {
            open: true, selectedUser: selectedStudent, purchase: packageItem
        }
        update && update({modals: {selectStudent: {$shallow: selectStudentModal}}})
        changed && changed()
    }
    
    function handleRemoveStudentClick() {
        if (packageItem?.assigned) {
            notifyWarning('Para cambiar el estudiante deberá comunicarse con el equipo de soporte.');
        } else {
            update && update({packageItem: {data: {student: {$set: null}}}})
            changed && changed()
        }
	
    }

	return (
        <div className={className}>
            <Button variant='outline-primary' size='lg' className={clsx('w-100', {'d-none': hasStudent || !update})} style={{ height: '86px' }} onClick={handleSelectStudentClick} >
                <Icon name='faUser' /> Selecciona un estudiante
            </Button>

            <div className={clsx({'d-none': !hasStudent})}>
                <div className='card-body px-0'>
                    <div className='d-flex text-black' style={{ padding: '0px 10px' }} >
                        <Avatar name={selectedStudent?.first_name} lastname={selectedStudent?.last_name} size={'sm'} />
                        <div className='flex-grow-1 ms-3 fn-s-14 justify-content-between' style={{ textAlign: 'left', display: 'grid', borderRight: !update ? 'none' : '1px solid #ccc', }} >
                            <span className='text-capitalize'> Estudiante: {selectedStudent?.first_name}{' '} {selectedStudent?.last_name} </span>
                            <span>Email: {selectedStudent?.email}</span>
                        </div>
                        <div className={clsx({'d-none': !update})}>
                            <span className='span--close' style={{ fontSize: '34px', marginLeft: '15px', marginRight: '5px', }} onClick={handleRemoveStudentClick} > <Icon name='faXmark' /> </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	)
}

export {SelectStudent as default}